import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { t } from '../../../../../i18n';
import CourseItem from '../course-item';
import './styles.scss';

const RedeemCoursesList = ({ courses, isLoading, isError, selectedCourseId, onSelectedCourseIdChange }) => {
  if (isError && !isLoading) {
    return <Alert variant="danger">{t('SERVER_ERROR')}</Alert>;
  }

  return (
    <div className="redeem-courses-list">
      <h2>{t('DIGITAL_COURSES.GIFT_CARD_REDEEM.SELECT_COURSE')}</h2>
      <div className="redeem-courses-list__grid">
        {!courses && isLoading && [0, 1, 2].map(i => <CourseItem.Placeholder key={i} />)}
        {courses?.map(c => (
          <CourseItem
            key={c.id}
            course={c}
            isSelected={c.id === selectedCourseId}
            onSelect={() => onSelectedCourseIdChange(c.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default RedeemCoursesList;
